import { createSlice } from "@reduxjs/toolkit";

interface DepositStateType {
  depositSuccess: boolean;
}

let initialState: DepositStateType = {
  depositSuccess: false,
};

const depositSlice = createSlice({
  name: "depositStoreModule",
  initialState,
  reducers: {
    clearDepositState: (state) => {
      state.depositSuccess = initialState.depositSuccess;
    },
    setSuccess: (state, action) => {
      state.depositSuccess = action.payload;
    }
  },
});

export const { setSuccess, clearDepositState } = depositSlice.actions;

export const DepositReducer = depositSlice.reducer;
